<!-- @format -->

<section
	id="hmf-hero-banner"
	class="{{ textBoxPositionVariants[textBoxPosition] }} hmf-hero-banner-container">
	<div class="hmf-hero-banner-image-container">
		@if (image) {
			<picture>
				@if (mobileImage) {
					<source
						[srcset]="mobileImage"
						media="(max-width: 766px)" />
				}
				<img
					[src]="image"
					class="loaded"
					[attr.alt]="altText"
					loading="lazy" />
			</picture>
		}
	</div>
	<div class="hmf-hero-banner-copybox-container">
		<div
			class="hmf-hero-banner-copybox hmf-mx-m-0 hmf-p-s hmf-px-m-l mobile-float-center {{
				textColorVariants[textColor]
			}}"
			[ngClass]="textBoxBackground ? 'background' : 'no-background'">
			@if (headline && headlineIsH1) {
				<h1 class="hmf-display-m hmf-display-m-l hmf-display-l-xl hmf-pb-xxs">
					{{ headline }}
				</h1>
			}
			@if (headline && !headlineIsH1) {
				<h2 class="hmf-display-m hmf-display-m-l hmf-display-l-xl hmf-pb-xxs">
					{{ headline }}
				</h2>
			}
			@if (subhead) {
				<p class="hmf-body-bold-m hmf-subheader-bold-s-l hmf-header-l-m hmf-mb-xxs">
					{{ subhead }}
				</p>
			}
			@if (legalText && legalTextLink) {
				<p class="hmf-hero-banner-details-text hmf-legal-s hmf-mb-m-xxs hmf-mb-0">
					{{ legalText }} <a href="{{ legalTextLink }}">More details</a>
				</p>
			}
			@if (link && buttonLabel) {
				<a
					class="hmf-mb-s cta-button"
					homefield-button
					height="base"
					[variant]="buttonStyle"
					[href]="link"
					[attr.altText]="buttonLabel"
					[attr.aria-label]="buttonLabel"
					[dataEm]="dataEm">
					{{ buttonLabel }}
				</a>
			}
		</div>
	</div>
</section>
